import {FC} from "react";
import {Button} from "@interstate/components/Button";
import {ClipboardIcon} from "@interstate/components/Icons";

export const CopyButton: FC<{
  content: string | undefined;
  qualifier: string;
}> = ({content, qualifier}) => {
  const onClick = async () => {
    if (content) {
      await navigator.clipboard.writeText(content);
    }
  };

  return (
    <Button
      className={"copy-button"}
      id={`copy-${qualifier}-button`}
      data-testid={`copy-${qualifier}-button`}
      buttonStyle={"tertiary"}
      icon={<ClipboardIcon />}
      onClick={onClick}
    />
  );
};
